import styles from "./styles.module.scss";
import React, {memo} from "react";
import LazyAssets from "@/app/utils/assets_widget";
import {ThirtyText} from "@/app/components/texts";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import usePreviousPlaces from "@/app/features/home/components/previous_places/slice";
import GameRowWidget from "@/app/components/game_row_widget";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import {useMediaQuery} from "@/app/utils/custom_function";

interface Props {
}

const PreviousPlaces: React.FC<Props> = () => {
  const {state, onMatchClick} = usePreviousPlaces();
  const isDesktop = useMediaQuery('(min-width:1024px)');

  return (
    <div className={styles.previousPlaces}>
      <div className={styles.title}>
        <LazyAssets.PreviousPlaces/>
        <ThirtyText text={t(s.previousPlaces)}/>
      </div>
      
      {state.isLoading && (
        <div className={styles.loading}>
          <CircularProgressIndicator isGreen />
        </div>
      )}
      
      {state.hasError && (
        <div className={styles.error}>
          <ThirtyText text={state.hasError} />
        </div>
      )}
      
      {!state.isLoading && !state.hasError && state.archivedMatches.length === 0 && (
        <div className={styles.emptyPage}>
          <ThirtyText text={t(s.nothingYet)}/>
        </div>
      )}
      
      {!state.isLoading && !state.hasError && state.archivedMatches.length > 0 && (
        <div className={styles.matchesList}>
          {state.archivedMatches.map((match) => (
            <GameRowWidget 
              key={match.id} 
              match={match} 
              onClick={onMatchClick}
              isDesktop={isDesktop}
              showOpensSpots={false}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(PreviousPlaces);